import { api } from 'utils';

export const setUpFuneralTrusts = (id: string) => {
  return api.post(`/provisions/setFuneralTrusts/${id}`);
};

export default {
  setUpFuneralTrusts,
};
